import App from '../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute} from '../../Router'
import Auth from '../../Auth'
import Utils from '../../Utils'

class providerprofileView {
  init(){
    document.title = 'Professional Profile'    
    this.render()    
    Utils.pageIntroAnim()
  }

  render(){
    const template = html`
      <va-app-header-blk title="Profile" user="${JSON.stringify(Auth.currentUser)}"></va-app-header-blk>

      <main class="profile">  
      
      <div class="profile-content"
      <br><br>
          <h1  style="font-size:16px; font-weight:700; color: #13A896; ">PUBLIC PROFILE</h1>
          
          
   
            ${Auth.currentUser && Auth.currentUser.avatar ? html`
              <sl-avatar shape="square"  style="--size: 150px; margin-bottom: 1em;" image=${(Auth.currentUser && Auth.currentUser.avatar) ? `${App.apiBase}/images/${Auth.currentUser.avatar}` : ''}></sl-avatar>
            `:html`
            <sl-avatar shape="square" style="--size: 150px;    margin-bottom: 1em;"></sl-avatar>
            `}


      <div id="profile-content">

      

      <div class="profile-content-container">

          <div class="profile-content-titles">
            <p >Firstname </p>
            <p> Lastname</p>
            <p> Phone Number</p>
            <p> Email</p>
            <p>Address</p>
         </div>


            <div class="profile-content-info">
                  <p >${Auth.currentUser.firstName} </p>
                  <p> ${Auth.currentUser.lastName}</p>
                  <p> ${Auth.currentUser.phone}</p>
                  <p>${Auth.currentUser.email}</p>
                  <p>${Auth.currentUser.address}</p>
                  
          </div>

          </div>

          </div>
            
         

            <sl-button @click=${()=> gotoRoute('/editProfile')}>Edit Profile</sl-button>
            <sl-button @click="${() => Auth.signOut()}">Sign out</sl-button>

    </div>
</main>  











         
    `
    render(template, App.rootEl)
  }
}


export default new providerprofileView()